import pageHandle from '../api/pageHandle'
import checkPermission from '../utils/permission' // 引入权限检查
import { getFuncData, mapSelect, getSysDict, keyupQuery } from '@/api/pubData'

export default {
  install (Vue) {
    Vue.filter('dict', function (value, dictList) {
      return mapSelect(dictList, 'codeId', value, 'codeName') || value
    })
    Vue.filter('append', function (value, str) {
      return value ? (value + str) : ''
    })
    Vue.mixin({
      data () {
        return {
          baseUrl: '/api',
          pageQuery: true,
          pageHeight: window.innerHeight - 250 + 'px',
          // 对话框
          pageLoading: true, // 加载中
          dialogAdd: false, // 新增对话框
          dialogModify: false, // 更新对话框
          dialogDetail: false, // 详情对话框
          importShow: false, // 显示导入
          uploadField: '', // 上传字段
          showMore: false, // 显示更多
          pageDefaultProps: {
            value: 'value',
            label: 'label',
            children: 'children',
            parentValue: 'parentValue'
          },
          // 数据对象
          dataList: [], // 列表数据
          dataDetail: {}, // 详情数据
          dataSelectList: [],
          formEdit: {}, // 更新对象
          disabledAfterNow: {
            disabledDate (time) {
              var currDate = new Date()
              currDate.setHours(23, 59, 59)
              return time.getTime() > currDate.getTime()
            }
          },
          orderList: [], // 多列排序
          funcData: [], // 权限数据
          pageTotal: 0, // 数据总条数
          pageParam: { // 分页对象
            pageNo: 1, // 当前第几页
            pageSize: 30 // 每页多少条
          },
          idName: 'id',
          createTimeDate: [],
          userInfo: {},
          resizeFlag: false
        }
      },
      computed: {
        pageUrl () {
          return this.baseUrl + this.httpUrl
        },
        isAdmin () {
          return this.userInfo.userLevel === '1'
        }
      },
      watch: {
        pageParam: {
          handler (curVal, oldVal) {
            this.httpQuery()
          },
          deep: true
        }
      },
      mounted () {
        this.getPageHeight()
        this.getUserInfo()
        if (this.httpUrl) {
          this.keyupQuery()
          this.getFuncData()
          if (this.pageQuery && !Object.keys(this.$route.query).length) {
            this.httpQuery()
          } else {
            this.pageLoading = false
          }
        }
      },
      activated () {
        if (this.httpUrl) {
          window.onresize = this.getPageHeight
          this.getPageHeight()
        }
      },
      deactivated () {
        if (this.httpUrl) {
          window.onresize = null
        }
      },
      beforeDestroy () {
        if (this.httpUrl) {
          window.onresize = null
        }
      },
      methods: {
        ...pageHandle,
        checkPermission,
        getFuncData,
        mapSelect,
        getSysDict,
        keyupQuery,
        onQueryInit () {
          if (this.createTimeDate) {
            if (this.createTimeDate[0]) {
              this.formQuery['createTimeBegin'] = this.$dateFormat(this.createTimeDate[0], 'YYYY-MM-DD') + ' 00:00:00'
            } else {
              this.formQuery['createTimeBegin'] = ''
            }
            if (this.createTimeDate[1]) {
              this.formQuery['createTimeEnd'] = this.$dateFormat(this.createTimeDate[1], 'YYYY-MM-DD') + ' 23:59:59'
            } else {
              this.formQuery['createTimeEnd'] = ''
            }
          } else {
            this.formQuery['createTimeBegin'] = ''
            this.formQuery['createTimeEnd'] = ''
          }
        },
        getUserInfo () {
          this.userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {}
        },
        getUserToken () {
          return sessionStorage.token
        }
      }
    })
  }

}
